import {
  ROUTINE_GET_ENTITIES,
  ROUTINE_SET_EDITED,
  ROUTINE_SET_EDITED_ROUTINE_DAYS,
  ROUTINE_SET_ROUTINE_DAYS,
  ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS
} from "../action-types/routine-days-types";
import { axiosAction } from "../../utils/axiosAction";

const ENDPOINT = `${process.env.REACT_APP_ENDPOINT_ROUTINE_DAYS}`;

export const setEdited = payload => ({
  type: ROUTINE_SET_EDITED,
  payload,
});
export const setEditedRoutineDays = payload => ({
  type: ROUTINE_SET_EDITED_ROUTINE_DAYS,
  payload,
});

export const getRoutineDays = restaurantId => async dispatch => {
  return axiosAction.get(`${ENDPOINT}/${restaurantId}`, ROUTINE_GET_ENTITIES, dispatch);
};

export const setRoutineDays = (
  restaurantId,
  deliveryDays,
) => async dispatch => {
  return axiosAction.put(`${ENDPOINT}/${restaurantId}`, ROUTINE_SET_ROUTINE_DAYS, dispatch, {
    deliveryDays: deliveryDays,
  });
};

export const setRestaurantsRoutineDays = (
  jsonData
) => async dispatch => {
  return axiosAction.put(`${ENDPOINT}/massUpload`, ROUTINE_SET_RESTAURANTS_ROUTINE_DAYS, dispatch, jsonData
  );
};
